import { render, staticRenderFns } from "./TransactionPaidCall.vue?vue&type=template&id=64377909&"
import script from "./TransactionPaidCall.vue?vue&type=script&lang=ts&"
export * from "./TransactionPaidCall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports